<template>
  <div id="vin_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="srtHeader">Update Campaign & Recall Status</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="CampaignRecallVinBackLink" >
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content srt-create">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CampaignRecallVinForm">
                <h2>Campaign/Recall Details</h2>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="fpp_code"> Campaign/ FFP Code:</label>
                    <input type="text" class="form-control" v-model="ffp_code" id="fpp_code" placeholder="Campaign/ FFP Code" name="fpp_code" :disabled="true">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="fpp_description"> FFP Description:</label>
                    <input type="text" class="form-control" v-model="ffp_description" id="fpp_description" placeholder="FPP Description" name="fpp_description" :disabled="true">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="campaign_start_date"> Campaign Start Date:</label>
                    <input type="text" class="form-control" v-model="campaign_start_date" id="campaign_start_date" placeholder="Campaign Start Date" name="campaign_start_date" :disabled="true">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="campaign_end_date"> Campaign End Date:</label>
                    <input type="text" class="form-control" v-model="campaign_end_date" id="campaign_end_date" placeholder="Campaign End Date" name="campaign_end_date" :disabled="true">
                  </div>
                </div>
                <h2>VIN Details</h2>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label" for="vin"> VIN:</label>
                    <input type="text" class="form-control" v-model="vin" id="vin" placeholder="VIN Number" name="vin" :disabled="true">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="status">Status:</label>
                    <v-select v-model="vinStatus" name="status" placeholder="Select Status."
                              label="text" :options="vinStatusArr">
                    </v-select>
                    <div class="field-error">{{status_error_msg}}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="claim_date">Claim Date:</label>
                    <date-picker placeholder="MM/DD/YYYY" id="claim_date" name="claim_date"
                                 v-model="claim_date"
                                 :config="options"></date-picker>
                    <div class="field-error">{{claim_date_error_msg}}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="claim_number">Claim Number:</label>
                    <span style="font-size: 14px;">{{ claimNumberCount }}/100</span>
                    <input type="text" class="form-control" v-model="claim_number" id="claim_number" placeholder="Enter Claim Number" name="claim_number">
                    <div class="field-error">{{ claim_number_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="comment">Comment:</label>
                    <span style="font-size: 14px;">{{ commentCount }}/250</span>
                    <textarea class="form-control" v-model="comment" ref="textarea" id="comment" rows="5" maxlength="250"></textarea>
                    <span class="field-error">{{ comment_error_msg }}</span>
                  </div>
                </div>
                <div class="from-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="createSrtBtn" class="btn btn-primary" v-on:click.prevent="UpdateVin">
                    <i class="fp-reload"> </i>  Update
                  </button>
                  <button type="submit" id="cancelSrtBtn" class="btn btn-tertiary" v-on:click.prevent="CampaignRecallVinBackLink" >
                    <i class="fp-close"> </i>  Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

export default {
  name: "CampaignRecallVinCreate",
  components: {
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
  },
  mixins:[commonMixins,contractMixins],
  metaInfo() {
    return {title: "Campaign & Recall Status Edit | " + process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    errorMsg: "",
    options: {
      format: 'MM/DD/YYYY',
      useCurrent: true,
      widgetPositioning:{
        vertical:'bottom'
      }
    },
    ffp_code: "",
    ffp_description: "",
    campaign_start_date: "",
    campaign_end_date: "",
    vin: "",
    vinStatus: "",
    vinStatusArr: [],
    status_error_msg: "",
    claim_date: "",
    claim_date_error_msg: "",
    comment: "",
    comment_error_msg: "",
    claimNumberCount: 0,
    claim_number: "",
    claim_number_error_msg: "",
    vinId: null,
    commentCount: 0,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0){
        for (const element of permissions){
          if(element.name === 'ev_list_campaign_recall_vin' || element.name === 'ev_edit_campaign_recall_vin'){
            this.cantAccessPage = true;
          }
        }
      }
    },
    claim_number: function (value) {
      if (value != null){
        if(value.length > 0){
          this.claim_number_error_msg = "";
        }
        if (value.length > 100) {
          this.claim_number = value.substring(0, 100);
        }
        this.claimNumberCount = value.length;
      }
    },
    comment: function (value) {
      if (value != null){
        if(value.length > 0){
          this.comment_error_msg = "";
        }
        if (value.length > 250) {
          this.comment = value.substring(0, 250);
        }
        this.commentCount = value.length;
      }
    },
  },
  mounted: function() {
    var self = this;
    self.getPermissions();
    self.loadFieldData(['campaign_vehicle_status']);
    this.vinId = this.$route.params.id;
    this.loadVinData();

  },
  methods: {
    CampaignRecallVinBackLink(){
      this.$router.push("/campaign-recall-status/list");
    },
    UpdateVin(){
      var self = this;
      self.loading = true;
      let validity = this.validateFormFields();
      if(validity){
        var fields = this.prepareFormFields();
        $.ajax({
          url: process.env.ROOT_API + "/campaign-recall-vin/update",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function(data){
            self.loading = false;
            if(data.status === "success"){
              self.CampaignRecallVinBackLink();
            }else{
              $("#errorMsg").html(data.message);
              $(".alert-warning").toggleClass("show");
              setTimeout(function () {
                $(".alert-warning").removeClass("show");
                $(".alert-warning").addClass("hide");
              }, 10000);
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            if (jqXHR.status === 0) {
              self.errorMsg = "Remote server cannot be reached";
            } else {
              //redirect to login page if user not authenticated
              if (jqXHR.status === 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("tkn");

                self.$router.push("/");
              }
              $("#errorMsg").html(jqXHR.responseJSON.message);
              $(".alert-warning").toggleClass("show");
              setTimeout(function () {
                $(".alert-warning").removeClass("show");
                $(".alert-warning").addClass("hide");
              }, 10000);
            }
          }
        })
      }else{
        self.loading = false;
      }
    },
    loadVinData(){
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/campaign-recall-vin/" + self.vinId,
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.ffp_code = data.content.ffp_code;
            self.ffp_description = data.content.ffp_description;
            self.campaign_start_date = data.content.campaign_start_date;
            self.campaign_end_date = data.content.campaign_end_date;
            self.vin = data.content.vin;
            self.vinStatus = {
              value: data.content.status,
              text: data.content.status.replace(/\b\w/g, char => char.toUpperCase())
            };
            self.claim_date = data.content.claim_date;
            self.claim_number = data.content.claim_number;
            self.comment = data.content.comment;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (jqXHR.status === 0) {
            self.errorMsg = "Remote server cannot be reached";
          } else {
            //redirect to login page if user not authenticated
            if (jqXHR.status === 401) {
              //clear previous data
              localStorage.removeItem("user_obj");
              localStorage.removeItem("tkn");

              self.$router.push("/");
            }
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    },
    validateFormFields(){
      this.status_error_msg = "";
      this.claim_date_error_msg = "";
      this.claim_number_error_msg = "";
      let validity = true;

      if(this.vinStatus == "" || this.vinStatus == null){
        this.status_error_msg = "Status needs to be selected!";
        validity = false;
      }
      if(this.claim_date == "" || this.claim_date == null){
        this.claim_date_error_msg = "Claim date needs to be selected!";
        validity = false;
      }
      if(this.claim_number == "" || this.claim_number == null){
        this.claim_number_error_msg = "Claim number needs to be entered!";
        validity = false;
      }
      return validity;
    },
    prepareFormFields(){
      var fields = $('#CampaignRecallVinForm').serializeArray();
      fields.push({name: "id",value: this.vinId});
      fields.push({name: "status",value: this.vinStatus.value});
      fields.push({name: "comment",value: this.comment});

      return fields;
    }
  }
};
</script>

<style scoped>
.data-table table.vgt-table .fp-log-file-format {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignRecallVinCreate.vue